import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // welcome page
    {
      path: '/sites/:siteId',
      name: 'Welcome Page',
      component: () => import('@/views/WelcomePage'),
    },
    // Home Page
    {
      path: '/',
      name: 'Welcome',
      component: () => import('@/views/WelcomePage'),
    },
    {
      path: '/home',
      name: 'HomePage',
      component: () => import('@/views/Home'),
    },
    // Passcode Reset
    {
      path: '/passcode/reset/:siteId',
      name: 'Confirm Mobile',
      component: () => import('@/views/passcodereset/ConfirmMobileNumber'),
    },
    {
      path: '/passcode/:userId/:linkId',
      name: 'Link Validation',
      component: () => import('@/views/passcodereset/LinkValidation'),
    },
    {
      name: 'New Passcode',
      path: '/passcode/update',
      component: () => import('@/views/passcodereset/CreateNewPasscode'),
    },
    // Not Using
    {
      path: '/qr-scan/:organization_id/:digi_board_id',
      name: 'QrScanHome',
      component: () => import('@/views/qrscan/LandingPage'),
    },
    // Alert Response
    {
      path: '/alerts/responses/:responseId',
      name: 'Alert Response',
      component: () => import('@/views/AlertResponsePage'),
    },
    // Check-In
    {
      path: '/:siteId/check-in/contractor',
      name: 'Checkin',
      component: () => import('@/views/process/Checkin/CheckInLandingPage'),
    },
    {
      path: '/:siteId/check-in/visitor',
      name: 'Visitor Checkin',
      component: () => import('@/views/process/Checkin/visitorcheckin/VisitorCheckInLanding'),
    },
    {
      path: '/:siteId/check-in/staff',
      name: 'Staff Checkin',
      component: () => import('@/views/process/Checkin/staffcheckin/StaffCheckInLanding'),
    },
    {
      path: '/check-in/success',
      name: 'Checkin Success',
      component: () => import('@/views/process/Checkin/CheckInSuccessPage'),
    },
    // Check-Out
    {
      path: '/:siteId/check-out/contractor',
      name: 'Checkout',
      component: () => import('@/views/process/Checkout/CheckOutLandingPage'),
    },
    {
      path: '/:siteId/check-out/visitor',
      name: 'Visitor Checkout',
      component: () => import('@/views/process/Checkout/visitorcheckout/VisitorCheckOutLanding'),
    },
    {
      path: '/:siteId/check-out/staff',
      name: 'Staff Checkout',
      component: () => import('@/views/process/Checkout/staffcheckout/StaffCheckOutLanding'),
    },
    // Register
    {
      path: '/:siteId/register',
      name: 'Register',
      component: () => import('@/views/process/Register/RegisterLandingPage'),
    },
    // User Profile
    {
      path: '/user',
      name: 'User Profile',
      component: () => import('@/views/drawer/UserProfile'),
    },
    // User Activity
    {
      path: '/activity',
      name: 'User Activity',
      component: () => import('@/views/drawer/UserActivities'),
    },
    // User Documents
    {
      path: '/uploads',
      name: 'Document Uploads',
      component: () => import('@/views/drawer/UserUploadedDocs'),
    },
    // Logout
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('@/views/Logout'),
    },
    // About
    {
      path: '/about',
      name: 'About',
      component: () => import('@/components/About'),
    },
    // Unknown
    {
      path: '/*',
      name: 'Not Found',
      component: () => import('@/views/app/404.vue'),
    },
  ],
});

export default router;
